module.exports = __webpack_public_path__ + "img/5-1.c6664c0b.png";